import * as React from 'react';

import {
  ApButtonMain,
  ApButtonSecondary,
  // ApModal,
} from '@alixpartners/ui-components';

import {
  InputModalContent,
  InputModalFooter,
  StyledApModal,
} from './ErrorModal.styles';

interface IConfirmModalProps {
  header: string;
  errorText: string;
  isOpen: boolean;
  onModalClose: () => void;
  onRetry: () => void;
}

export const ErrorModal: React.FC<IConfirmModalProps> = ({
  isOpen,
  header,
  onModalClose,
  onRetry,
  errorText,
}) => {
  return (
    <StyledApModal
      header={header || 'Error'}
      isOpen={isOpen}
      hasClosed={onModalClose}
      footer={() => (
        <InputModalFooter>
          <ApButtonMain
            onClick={() => {
              onRetry();
              onModalClose();
            }}
            disabled={false}
          >
            Reload page
          </ApButtonMain>
          <ApButtonSecondary onClick={onModalClose}>Cancel</ApButtonSecondary>
        </InputModalFooter>
      )}
    >
      <InputModalContent>{errorText}</InputModalContent>
    </StyledApModal>
  );
};
